<template>
  <el-row :gutter="5">
    <el-table
      :data="tableResult"
      style="width: 100%"
      :row-class-name="tableRowClassName"
    >
      <el-table-column type="index" label="Linha" width="100">
      </el-table-column>
      <el-table-column label="Status" property="status" width="150">
      </el-table-column>
      <el-table-column label="Resultado" property="result"> </el-table-column>
    </el-table>
  </el-row>
</template>

<script>
import { PrepostService } from "@/services/customers/prepost.services";

export default {
  name: "ImportPrepost",
  props: ["records"],
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (row.status === "Erro") {
        return "warning-row";
      } else if (row.status === "Sucesso") {
        return "success-row";
      }
      return "";
    },
  },
  computed: {},
  data() {
    return {
      tableResult: [],
    };
  },
  async mounted() {
    const vm = this;
    for (const record of vm.records) {
      vm.tableResult.push({ status: "Aguardando", result: "", data: record });
    }

    const loading = vm.$loading(vm.$options.loading);

    const sendPrepostData = async (data) => {
      if (data.error) {
        throw new Exception(data.error);
      }
      return await PrepostService.add(
        data.prepost.customer,
        data.prepost.sender,
        data.prepost.delivery,
        data.prepost.contact,
        data.prepost.object,
        data.prepost.complement,
        data.prepost.service,
        data.prepost.cardpost
      );
    };

    for (const record of vm.tableResult) {
      record.status = "Processando";
      try {
        if (record.data.error) {
          record.status = "Erro";
          record.result = record.data.error.error;
        } else {
          const prepost = await sendPrepostData(record.data);
          record.status = "Sucesso";
          record.result = prepost[0].tag;
        }
      } catch (e) {
        record.status = "Erro";
        record.result = e;
      }
    }
    loading.close();
  },
};
</script>

<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
